let kindeAuth = null;

export const initializeKindeAuth = kindeAuthInstance => {
    kindeAuth = kindeAuthInstance;
};

export const logoutKindeAuth = async () => {
    if (!kindeAuth) {
        console.error('KindeAuth not initialized');
        window.location.href = '/welcome'; // Adjust this URL based on your login route
        return;
    }

    try {
        localStorage.clear();
        // await kindeAuth.logout();
        window.location.href = '/welcome';
    } catch (error) {
        console.error('Error logging out:', error);
        window.location.href = '/welcome';
    }
};

export const getKindeToken = async () => {
    if (!kindeAuth) {
        throw new Error('KindeAuth not initialized');
    }

    try {
        const token = await kindeAuth.getToken();
        if (!token || token.trim() === '') {
            throw new Error('Failed to get valid token');
        }
        return token;
    } catch (error) {
        console.error('Token generation error:', error);
        await logoutKindeAuth();
        throw error;
    }
};
